import clsx from 'clsx';
import * as React from 'react';
import { Icon } from '../icon/icon';

interface IconBoxProps {
	icon: string;
	bgColor: string;
	textColor: string;
	size: 'small' | 'medium' | 'big';
}

export const IconBox: React.FC<IconBoxProps> = ({
	icon,
	bgColor,
	textColor,
	size,
}) => {
	return (
		<span
			className={clsx(
				`rounded-full flex justify-center items-center`,
				bgColor,
				{
					'w-8 h-8': size === 'small',
					'w-12 h-12': size === 'medium',
					'w-16 h-16': size === 'big',
				}
			)}
		>
			<Icon
				src={icon}
				className={clsx(textColor, {
					'!w-4 !h-4': size === 'small',
					'!w-6 !h-6': size === 'medium',
					'!w-8 !h-8': size === 'big',
				})}
			/>
		</span>
	);
};
